import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=623a5551&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=623a5551&prod&lang=scss&scoped=true"
import style1 from "./uploadImg.vue?vue&type=style&index=1&id=623a5551&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a5551",
  null
  
)

export default component.exports